module.exports = __webpack_public_path__ + "img/video1.8fe75f80.png";